import { useHotkeys } from '@tanstack/react-hotkeys'

import { modalActions } from '../modals/modal.store'

/**
 * Register all Rundown-page level shortcuts here.
 */
export function RundownHotkeys() {
  useHotkeys([
    // Shortcuts modal
    {
      hotkey: 'Mod+/',
      callback: () => {
        modalActions.toggle('SHORTCUTS', {})
      },
    },
    // Mentions modal
    {
      hotkey: 'Alt+M',
      callback: () => {
        modalActions.toggle('MENTIONS', {})
      },
    },
    // Variables modal
    {
      hotkey: 'Alt+V',
      callback: () => {
        modalActions.toggle('VARIABLES', {})
      },
    },
  ])

  return null
}
